<template>
  <md-field>
    <label :for="id">{{ label }}</label>
    <md-select v-model="selectedCountry" :name="name" :id="id">
      <md-option
        v-for="item in countries"
        :key="item.iso3"
        :label="item.name"
        :value="item.iso3"
      >
        {{ item.name }}
      </md-option>
    </md-select>
  </md-field>
</template>
<script>
export default {
  name: "aer-country-select",
  model: {
  },
  data: () => ({
    countries: []
  }),
  created() {
    this.getCountries();
  },
  props: {
    id: {
      default: 'country',
      type: String
    },
    name: {
      default: 'country',
      type: String
    },
    label: {
      default: 'Country',
      type: String
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    selectedCountry: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    getCountries() {
      this.countries = this.$store.state.options.countries
    }
  }
};
</script>
<style></style>
